import { Component, Input, OnInit } from '@angular/core';
import { Site } from 'src/app/api/site/site';
import { SiteApiService } from 'src/app/api/site/siteApiService';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { Location as NavLocation } from '@angular/common';
import { AssetApiService } from 'src/app/api/asset/assetApiService';
import { LocationTreeNode } from './location-tree-node';
import { AssetSearchResult } from 'src/app/api/asset/search/assetSearchResult';

@Component({
  selector: 'site-location-tree',
  standalone: false,
  templateUrl: './site-location-tree.component.html',
  styleUrl: './site-location-tree.component.css'
})
export class SiteLocationTreeComponent implements OnInit {
  @Input() siteId: number | null | undefined = null;
  locationsLoading: boolean = false;
  site: Site | null = null;
  selectedNode: LocationTreeNode | null = null;

  treeControl = new NestedTreeControl<LocationTreeNode>(node => node.children);
  dataSource = new MatTreeNestedDataSource<LocationTreeNode>();

  constructor(private location: NavLocation,
    private siteApiService: SiteApiService,
    private assetApiService: AssetApiService) {
  }

  ngOnInit(): void {
    this.loadSite();
  }

  private loadSite(): void {
    if (!this.siteId) {
      console.error("Site ID is not provided.");
      return;
    }

    this.locationsLoading = true;
    this.siteApiService.getSite(this.siteId)
      .subscribe(x => {
        this.site = x;

        var root = LocationTreeNode.fromSite(x);
        this.loadSiteAssets(root);
        this.dataSource.data = [root];
        this.locationsLoading = false;
      });
  }

  private loadSiteAssets(rootNode: LocationTreeNode): void {
    this.assetApiService.searchAssetsForLocation(this.siteId!, null)
      .subscribe({
        next: (assets) => this.handleAssetResults(rootNode, assets),
        error: () => { console.error("Error loading assets for site", this.siteId); }
      });
  }

  hasChild = (_: number, node: LocationTreeNode) => node.hasChildren();

  onNodeSelect(node: LocationTreeNode): void {
    this.selectedNode = node;

    if (!node.assetsLoaded) {
      this.assetApiService.searchAssetsForLocation(this.siteId!, node.name!)
        .subscribe({
          next: (assets) => this.handleAssetResults(node, assets),
          error: () => { console.error("Error loading assets for location", this.siteId, node.name); }
        });
    }
    else if (node.type == "asset" && node.underlyingData == null) {
      this.assetApiService.getAsset(node.assetId!)
        .subscribe(x => {
          node.underlyingData = x[0];
        });
    }
  }

  private handleAssetResults(node: LocationTreeNode, assets: AssetSearchResult[]) {
    node.children = node.children
      .concat(assets.map(x => LocationTreeNode.fromAsset(x)))
      .sort(LocationTreeNode.compare);

    node.assetsLoaded = true;

    //needed to trigger change detection
    var data = this.dataSource.data;
    this.dataSource.data = [];
    this.dataSource.data = data;

    this.treeControl.expand(node);
  }

  back(): void {
    this.location.back()
  }
}
